import { createGlobalStyle } from "styled-components";

import NotoBoldEot from "./fonts/NotoSans-Bold.eot";
import NotoBoldSVG from "./fonts/NotoSans-Bold.svg";
import NotoBoldTtf from "./fonts/NotoSans-Bold.ttf";
import NotoBoldWoff from "./fonts/NotoSans-Bold.woff";
import NotoEot from "./fonts/NotoSans.eot";
import NotoSVG from "./fonts/NotoSans.svg";
import NotoTtf from "./fonts/NotoSans.ttf";
import NotoWoff from "./fonts/NotoSans.woff";
import JostEot from "./fonts/Jost-Regular.eot";
import JostSVG from "./fonts/Jost-Regular.svg";
import JostTtf from "./fonts/Jost-Regular.ttf";
import JostWoff from "./fonts/Jost-Regular.woff";
import RedHatEot from "./fonts/RedHatDisplay-Regular.eot";
import RedHatSVG from "./fonts/RedHatDisplay-Regular.svg";
import RedHatTtf from "./fonts/RedHatDisplay-Regular.ttf";
import RedHatWoff from "./fonts/RedHatDisplay-Regular.woff";

export const GlobalStyle = createGlobalStyle`
@font-face {
    font-family: 'Noto Sans_Bold';
    src: url(${NotoBoldEot});
    src: 
        url(${NotoBoldWoff}) format('woff'),
        url(${NotoBoldTtf}) format("truetype"),
        url(${NotoBoldSVG}) format('svg');
        font-weight: normal;
        font-style: normal;
    }

@font-face {
    font-family: 'Noto Sans';
    src: url(${NotoEot});
    src: 
        url(${NotoWoff}) format('woff'),
        url(${NotoTtf}) format("truetype"),
        url(${NotoSVG}) format('svg');
        font-weight: normal;
        font-style: normal;
    }
 
@font-face {
  
    font-family: 'Jost';
    src: url(${JostEot});
    src: 
        url(${JostWoff}) format('woff'),
        url(${JostTtf}) format("truetype"),
        url(${JostSVG}) format('svg');
        font-weight: normal;
        font-style: normal;
    }
 
@font-face {
    font-family: 'Red Hat Display';
    src: url(${RedHatEot});
    src: 
        url(${RedHatWoff}) format('woff'),
        url(${RedHatTtf}) format("truetype"),
        url(${RedHatSVG}) format('svg');
        font-weight: normal;
        font-style: normal;
    }
 

  html {
    box-sizing: border-box;
    font-family: "Noto Sans", Sans-Serif;
    scroll-behavior: smooth;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  a {
    cursor: pointer;
    text-decoration:none;
  }
 
  ul, li, h1, h2, h3, p  {
    margin: 0;
    padding: 0;
  }

  ul {
    list-style: none;
  }

  button {
    border: 0;
    outline: 0;
  }

  body {
   max-width: 1920px; 
   background-color: #FFFFFF;
   margin: 0 auto;
   color: #000000;
   overscroll-behavior: none;
   width: 100%;
  }

  #app {
    box-shadow: 0 0 10px rgba(0,0,0,.05);
    overflow-x: hidden;
  }
`;
